module.exports = __webpack_public_path__ + "img/cb-refresh.35b7eae1.svg";